// NPM Imports
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, Input, Button, Label, Toastr } from "@revvsales/components";
import uuid from "react-native-uuid";
import Modal from "react-responsive-modal";

// Component Imports
import Table from "../RevvTable";
import CustomText from "./CustomText";
import CustomImage from "./CustomImage";
import CustomDealTable from "./CustomDealTable";
import CustomQuoteTable from "./CustomQuoteTable";
import CustomPageBreak from "./CustomPageBreak";
import CustomLineSpace from "./CustomLineSpace";
import CustomQuoteTableWrapper from "./CustomQuoteTableWrapper";
import EmptyDocumentPlaceholder from "./EmptyDocumentPlaceholder";
import SignatureContainer from "./SignatureContainer";
import GoogleSheetContainer from "./GoogleSheetContainer";
import AddOptionToClauseBtn from "./AddOptionToClauseBtn";
import AddToClausesListBtn from "./AddToClausesListBtn";
import CreateClause from "../Document/CreateClause";
import ContentLock from "./ContentLock";
import StripePaymentContainer from "./StripePaymentContainer";
import { ConfirmationBox, UpgradePopUp } from "../../commonComponents";

// Action Imports
import {
  changeToolsView,
  makeActiveEditor,
  updateDocumentClickedComponentID,
  updateHoveredDocumentSectionId,
  updateDraggedSection,
  preventComponentToDeactivate,
  forceUpdateEditorSectionIdAction,
} from "../../actions/DocumentActions/index";
import { QuotationActions, EditorActions } from "../../actions";
import {
  addClause,
  saveClause,
  removeClause,
  addClauseOptions,
  editClauseOption,
  updateTemplateSection,
} from "../../actions/DocumentTemplateActions/templateActions";

import ToolbarActions from "../../actions/ToolbarActions";

// Internal Imports
import { DOCUMENTS, COMMON, EVENTS, FEATURES } from "../../constants";
// import { emptyNote } from "../Notes/utils";
import { GlobalUtils, AmplitudeUtils, DocumentUtils } from "../../utils";
import ManageColumnsPopup from "./ManageColumnsPopup";
import { updateSecInDocReduxAndBackend } from "./methods";
import getDragImage from "../../utils/dragUtils";

// Destructuring
const { nukeEditorState } = EditorActions;
const { DOCUMENT_LABELS } = COMMON;
const { FEATURES_NAME } = FEATURES;
const {
  toggleTabView,
  setSectionDataForActiveSignatureInRightToolPane,
  setSectionDataForActivePaymentButtonInRightToolPane,
} = QuotationActions;
const {
  DOCUMENT_MODE,
  STACK_IGNORE_LIST,
  COMPONENT_FEATURE,
  DOCUMENT_COMPONENT_TYPES,
  TEMPLATE_SHOW_CLAUSES_FOR_COMPONENT_TYPE,
  TEMPLATE_SHOW_CLAUSE_OPTIONS_FOR_COMPONENT_TYPE,
} = DOCUMENTS;
const { updateAddComponentinToolbarAction } = ToolbarActions;
const { truncateString } = GlobalUtils;
const { amplitudeLogEvent } = AmplitudeUtils;
const {
  getComponentFromInfo,
  emptyContainer,
  isComponentCloneable,
} = DocumentUtils;

class DocumentItems extends React.Component {
  sectionActionBtnsRef = React.createRef();

  state = {
    showClauseSave: false,
    showDeleteConfirmation: false,
    showRemoveClauseConfirmation: false,
    showRemoveClauseOptionsConfirmation: false,
    replaceImage: false,
    showAddComponentBtns: false,
    showContentLockUpgradePopup: false,
    showAddClauseUpgradePopup: false,
    showManageColumnPopup: false,
    columnsHeaders: [],
    hiddenColumnsForGsheet:
      this.props.section &&
      this.props.section.type === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET &&
      this.props.section.data &&
      this.props.section.data.attributes &&
      this.props.section.data.attributes.hiddenCols
        ? this.props.section.data.attributes.hiddenCols
        : [],
    openModal: false,
    AltTextValue: null,
    addedAltTextBool: false,
    lastAddedAltText: "",
    dragImg: null,
  };

  componentDidMount() {
    const img = document.createElement("img");
    img.src = getDragImage(this.props.section.type);
    this.setState({ dragImg: img });
  }

  _handleClauseList = () => {
    if (this.props.section && !this.props.section.lock) {
      this.props.nukeEditorState();
    }
    this.setState({ showRemoveClauseConfirmation: true });
  };

  // create clauses feature
  _clauseButton = () => {
    const { mode, section } = this.props;
    const { clauseID, id, clauseOptions } = section;

    if (!COMPONENT_FEATURE[mode].createClause) {
      return null;
    }

    if (
      TEMPLATE_SHOW_CLAUSES_FOR_COMPONENT_TYPE.indexOf(section.type) < 0 ||
      clauseOptions
    ) {
      return null;
    }
    if (clauseID === undefined || clauseID === null) {
      return <AddToClausesListBtn btnAction={this._convertToClause} id={id} />;
    }
    return (
      <span
        className="btn-icon"
        id="remove-from-clauses-list-btn"
        onMouseDown={this._handleClauseList}
        onKeyDown={() => {}}
        role="button"
        tabIndex={0}>
        <Tooltip placement="left" overlay="Remove from clauses list">
          <FontAwesomeIcon icon={["far", "times-circle"]} />
        </Tooltip>
      </span>
    );
  };

  // add clause options feature
  _clauseOptionButton = () => {
    const { mode, section, itemType, clauseOptionsDetails } = this.props;
    const { clauseOptions, id, clauseID } = section;

    // check if clause option feature is allowed for this mode or not
    if (
      !COMPONENT_FEATURE[mode].createClauseOption ||
      itemType === DOCUMENT_COMPONENT_TYPES.COVERPAGE ||
      itemType === DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER ||
      itemType === DOCUMENT_COMPONENT_TYPES.HEADER ||
      itemType === DOCUMENT_COMPONENT_TYPES.FOOTER
    ) {
      return null;
    }

    // check if clause option feature is allowed for this component type
    if (
      TEMPLATE_SHOW_CLAUSE_OPTIONS_FOR_COMPONENT_TYPE.indexOf(section.type) <
        0 ||
      clauseID
    ) {
      return null;
    }

    if (clauseOptions) {
      // if clause option is already attached then, show the both Edit and Remove button
      return (
        <Fragment>
          <Tooltip
            placement="top"
            overlay="Edit clause option"
            align={{ offset: [0, 3] }}>
            <span
              className="add-clause-btn"
              data-test="documentitems-edit-clause-btn"
              onMouseDown={() =>
                this.props.editClauseOption(section, clauseOptionsDetails)
              }
              onKeyDown={() => {}}
              role="button"
              tabIndex={0}>
              <i>
                <FontAwesomeIcon icon={["far", "pen-square"]} />
              </i>
              Edit Clause option
            </span>
          </Tooltip>
          <Tooltip
            placement="top"
            overlay="Remove from clauses list"
            align={{ offset: [0, 3] }}>
            <span
              className="add-clause-btn remove-clause-btn"
              data-test="documentitems-remove-clause-btn"
              onMouseDown={() =>
                this.setState({ showRemoveClauseOptionsConfirmation: true })
              }
              onKeyDown={() => {}}
              role="button"
              tabIndex={0}>
              <i>
                <FontAwesomeIcon icon={["far", "times-circle"]} />
              </i>
              Remove Clause option
            </span>
          </Tooltip>
        </Fragment>
      );
    }

    // check if section hs dynamic fields.
    // if dynamic fields are already attached to the section or if section is locked then,
    // disable the add clause option button
    const contentState = section.data;

    let isDfPresent = false;
    contentState.getBlockMap().forEach(block => {
      block.findEntityRanges(character => {
        const charEntity = character.getEntity();
        if (charEntity) {
          // could be `null`
          const contentEntity = contentState.getEntity(charEntity);
          if (contentEntity.getType() === "DYNAMICFIELD") {
            isDfPresent = true;
          }
        }
      });
    });

    if (isDfPresent || (section && section.lock)) {
      let tooltipText = "Cannot create clause options for locked blocks";
      if (isDfPresent) {
        tooltipText = `Cannot add clause option to locked blocks or blocks with ${DOCUMENT_LABELS[
          "dynamic-label"
        ].toLowerCase()} fields.`;
      }
      return (
        <Tooltip
          placement="top"
          overlay={tooltipText}
          align={{ offset: [0, 3] }}>
          <span
            className="add-clause-btn disabled"
            role="button"
            tabIndex={0}
            onMouseDown={() =>
              this.props.updateDocumentClickedComponentID(
                section.id,
                false,
                section.type,
              )
            }>
            <FontAwesomeIcon icon={["far", "layer-plus"]} />
            Add Clause Option
          </span>
        </Tooltip>
      );
    }
    // check if clause options is already attached or not
    return (
      <AddOptionToClauseBtn
        btnAction={this._convertToClauseOption}
        id={id}
        toggleUpgradePopup={this._toggleUpgradePopup}
      />
    );
  };

  _convertToClause = () => {
    if (this.props.section && !this.props.section.lock) {
      this.props.nukeEditorState();
    }
    this.setState({ showClauseSave: true });
  };

  _closeClausePopUp = () => {
    this.setState({ showClauseSave: false });
  };

  _convertToClauseOption = componentId => {
    const { mode } = this.props;
    // check if clause option feature is allowed for this mode or not
    if (COMPONENT_FEATURE[mode].createClauseOption) {
      this.props.addClauseOptions(componentId);
    }
  };

  _removeClauseOption = () => {
    const { mode, section } = this.props;
    // check if clause option feature is allowed for this mode or not
    if (COMPONENT_FEATURE[mode].createClauseOption) {
      const updatedSection = {
        ...section,
        clauseOptions: null,
        form_field: [],
      };
      this.props.updateComponent(updatedSection, undefined, false, section);
    }
  };

  _createClause = clauseName => {
    const { section, updateComponent } = this.props;
    const clauseId = uuid.v4();
    saveClause(clauseName, clauseId, section).then(response => {
      const clause = { id: response.Clause.id, name: response.Clause.name };
      this.props.addClause(clause);
      const newSection = { ...section, clauseID: clauseId, lock: true };
      updateComponent(newSection, undefined, false, newSection);
      this._closeClausePopUp();
    });
  };

  _removeClause = () => {
    const { section, updateComponent } = this.props;
    const { clauseID } = section;
    this.props.removeClause(clauseID);
    const newSection = { ...section, clauseID: null, lock: false };
    updateComponent(newSection, undefined, false, newSection);
  };

  // lock section feature
  _toggleSectionLock = (event, lock) => {
    event.preventDefault();
    const { section, clauseOptionsDetails } = this.props;
    if (!clauseOptionsDetails) {
      this.props.handleComponentLockUnlock(section, lock);
      this.props.updateDocumentClickedComponentID(null, true);
      this.props.updateHoveredDocumentSectionId(null);
    }
  };

  _toggleUpgradePopup = (type, flag) => {
    this.setState({ [type]: flag });
  };

  _lockButton = () => {
    const { section, mode, clauseOptionsDetails } = this.props;
    const { clauseID } = section;
    // for document, show only locked section because of added clause
    if (mode === "DOCUMENT") {
      if (clauseID) {
        return (
          <Tooltip
            placement="left"
            overlay="This clause is locked for any editing.">
            <span className="btn-icon locked-icon">
              <FontAwesomeIcon icon={["far", "lock"]} />
            </span>
          </Tooltip>
        );
      }
      return null;
    }

    // if lock is allowed for current mode or not
    if (
      !COMPONENT_FEATURE[mode].lockSection ||
      section.type === DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE_WRAPPER
    ) {
      return null;
    }
    // Implementing feature gating for Pricing Plan
    const isDisabled = !!clauseOptionsDetails;
    return (
      <ContentLock
        isDisabled={isDisabled}
        toggleSectionLock={this._toggleSectionLock}
        toggleUpgradePopup={this._toggleUpgradePopup}
        {...this.props}
      />
    );
  };

  _handleDeleteButton = section => {
    if (STACK_IGNORE_LIST.includes(section.type)) {
      this.setState({ showDeleteConfirmation: true });
    } else {
      this._deleteSection();
    }
    return null;
  };

  // delete feature
  _deleteButton = () => {
    const { section, mode } = this.props;

    if (
      (!COMPONENT_FEATURE[mode].deleteSection || section.lock === true) &&
      !section.removable
    ) {
      return null;
    }

    return (
      <Tooltip
        placement="top"
        overlay="Delete this block"
        align={{ offset: [0, 3] }}>
        <span
          data-test="documentitems-delete-the-content-btn"
          className="btn-icon"
          id="delete-the-content-btn"
          onMouseDown={() => this._handleDeleteButton(section)}
          role="button"
          tabIndex={0}>
          <FontAwesomeIcon icon={["far", "trash-alt"]} />
        </span>
      </Tooltip>
    );
  };

  // clone feature
  _cloneButton = () => {
    const { section, rowIndex, colIndex } = this.props;
    return (
      <Tooltip
        placement="top"
        overlay="Clone this block"
        align={{ offset: [0, 3] }}>
        <span
          data-test="documentitems-clone-the-content-btn"
          className="btn-icon"
          id="clone-the-content-btn"
          onMouseDown={() =>
            this.props.cloneSection(section, rowIndex, colIndex, true)
          }
          role="button"
          tabIndex={0}>
          <FontAwesomeIcon icon={["far", "clone"]} />
        </span>
      </Tooltip>
    );
  };

  // reorder feature
  _dragButton = () => (
    <Tooltip
      placement="top"
      overlay="Click and drag to reposition"
      align={{ offset: [0, 3] }}>
      <span
        draggable
        onDragStart={event => this._onDragStart(event, this.props.section)}
        onDragEnd={event => this._onDragEnd(event, this.props.section.id)}
        onMouseDown={event => this._handleDragClick(event)}
        data-test="documentitems-drag-the-content-btn"
        className="btn-icon"
        id="drag-the-content-btn"
        // eslint-disable-next-line prettier/prettier
        style={{ pointerEvents: "auto", }}
        role="button"
        tabIndex={0}>
        <FontAwesomeIcon icon={["far", "arrows-alt"]} />
      </span>
    </Tooltip>
  );

  // eslint-disable-next-line
  _handleDragClick(event) {
    this.props.preventComponentToDeactivate(false);
    // eslint-disable-next-line prefer-destructuring
    if (!event) event = window.event;

    // IE9 & Other Browsers
    if (event.stopPropagation) {
      event.stopPropagation();
    }
    // IE8 and Lower
    else {
      event.cancelBubble = true;
    }
  }

  _showManageColumnsForTable = section => {
    const columnsHeaders = this._createColumnHeaders(section);
    this.setState({
      showManageColumnPopup: true,
      columnsHeaders,
    });
  };

  _createColumnHeaders = section => {
    if (
      section &&
      section.data &&
      section.data.data &&
      section.data.data.length > 0
    ) {
      const firstRowData = section.data.data[0].data;
      const columnHeaders = [];
      firstRowData.forEach((col, index) => {
        let colName = "";
        if (col.data.html) {
          const span = document.createElement("span");
          span.innerHTML = col.data.html;
          colName = span.textContent || span.innerText;
        }
        let show = true;
        if (this.state.hiddenColumnsForGsheet.includes(index)) {
          show = false;
        }
        const colHeader = { id: index, name: colName, show };
        columnHeaders.push(colHeader);
      });
      return columnHeaders;
    }
    return [];
  };

  _manageColumnsButton = () => {
    const { section } = this.props;
    if (
      section.lock === true ||
      (section.data && section.data.data && section.data.data.length === 0)
    ) {
      return null;
    }
    return (
      <Tooltip
        placement="top"
        overlay="Choose table columns you want visible on your document"
        align={{ offset: [0, 3] }}>
        <span
          data-test="documentitems-delete-the-content-btn"
          className="btn-text"
          id="delete-the-content-btn"
          onClick={() => this._showManageColumnsForTable(section)}
          onMouseDown={() => this._showManageColumnsForTable(section)}
          onKeyDown={() => {}}
          role="button"
          tabIndex={0}>
          Manage Columns
        </span>
      </Tooltip>
    );
  };

  _deleteSection = () => {
    const { section, deleteComponent } = this.props;
    if (section) {
      if (section.lock === true && section.removable !== true) {
        return null;
      }
      if (section.type === DOCUMENT_COMPONENT_TYPES.EMPTY_SIGNATURE_CONTAINER) {
        this.props.setSectionDataForActiveSignatureInRightToolPane({});
        this.props.updateAddComponentinToolbarAction("doc-components");
        amplitudeLogEvent(EVENTS.EVENT_NAMES.SIGNATURE_BLOCK_DELETED);
      }
      if (section.type === DOCUMENT_COMPONENT_TYPES.STRIPE_PAYMENT_BUTTON) {
        this.props.setSectionDataForActivePaymentButtonInRightToolPane({});
        this.props.updateAddComponentinToolbarAction("doc-components");
      }
      if (
        section.type === DOCUMENT_COMPONENT_TYPES.HTML ||
        section.type === DOCUMENT_COMPONENT_TYPES.TABLE
      ) {
        this.props.nukeEditorState(true);
      }
      deleteComponent(section.id);
    }
    return null;
  };

  _clearReplaceImage = () => {
    this.setState(prevState => ({
      replaceImage: !prevState.replaceImage,
    }));
    this.props.disablePlusBtnHandler(false);
    const {
      updateDocumentClickedComponentID: updateDocumentClicked,
      section,
    } = this.props;

    updateDocumentClicked(section.id, false, section.type);
  };

  // edit button feature
  _editButton = () => {
    if (
      this.props.section.lock === true || // if image is locked
      this.props.section.type !== DOCUMENT_COMPONENT_TYPES.IMAGE || // if this section is not an image
      !this.props.section.data // if there is no image data
    ) {
      return null;
    }

    // Image field cases
    if (this.props.section.clauseOptions) {
      if (this.props.mode === DOCUMENT_MODE.TEMPLATE) {
        return null;
      }
    }

    if (this.props.totalRowItems === 1) {
      return (
        <Fragment>
          <div className="component-divide">
            <div className="divide-line" />
            <Tooltip
              placement="top"
              overlay="Replace image"
              align={{ offset: [0, 3] }}>
              <span
                data-test="replace-image-button"
                className="btn-icon"
                id="edit-sec-btn"
                onMouseDown={this._clearReplaceImage}
                onKeyDown={() => {}}
                role="button"
                tabIndex={0}>
                <FontAwesomeIcon icon={["far", "images"]} />
              </span>
            </Tooltip>
            <Tooltip
              placement="top"
              overlay="Add alt-text"
              align={{ offset: [0, 2] }}>
              <span
                data-test="alt-text-image-button"
                className="btn-icon"
                id="edit-sec-btns"
                onMouseDown={this._addAltText}
                onKeyUp={() => {}}
                role="button"
                tabIndex={0}>
                <FontAwesomeIcon icon={["far", "edit"]} />
              </span>
            </Tooltip>
            <div className="divide-line" />
          </div>
        </Fragment>
      );
    }
    return null;
  };

  _isBase64 = imageString => {
    if (
      typeof imageString === "string" &&
      (imageString.startsWith("data") ||
        (imageString.startsWith("<") && imageString.includes("<img ")))
    ) {
      return true;
    }
    return false;
  };

  _addAltText = () => {
    const {
      updateDocumentClickedComponentID: updateDocumentClicked,
      section,
    } = this.props;
    let altNewText = "";
    let newData;
    if (
      this.props.component.data &&
      typeof this.props.component.data === "string" &&
      !this._isBase64(this.props.component.data)
    ) {
      newData = JSON.parse(this.props.component.data);
      if (newData && newData.altText) {
        altNewText = newData.altText;
      }
    }
    this.setState({
      AltTextValue: altNewText,
      openModal: true,
    });
    this.props.disablePlusBtnHandler(false);
    updateDocumentClicked(section.id, false, section.type);
  };

  _handleKeyDown = e => {
    const { AltTextValue } = this.state;
    if (e.key === "Enter" && AltTextValue) {
      this._saveAltText();
    }
  };

  _isEmptyContainer = type => {
    if (type === DOCUMENT_COMPONENT_TYPES.EMPTY_CONTAINER) {
      return true;
    }
    return false;
  };

  _isGoogleSheet = type => {
    if (type === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET) {
      return true;
    }
    return false;
  };

  _decideDragActionBtns = () => {
    const { isLocked, draggedSection, section } = this.props;
    const isDragged = draggedSection && section.id === draggedSection.id;
    let actionBtns = null;
    if (!isLocked) {
      actionBtns = (
        <div
          className={`drag-button-container ${
            isDragged ? "dragged-component-button" : ""
          }   ${section.type === "Table" ? "table-drag-btn-container" : ""}`}
          data-test="document-item-drag-button-container">
          <div
            className="drag-button-action component-action"
            data-test="document-item-drag-button-action">
            {this._dragButton()}
          </div>
        </div>
      );
    }
    return actionBtns;
  };

  _decideSectionActionBtns = () => {
    const { isLocked, section, mode, isComponentActive } = this.props;
    const { type } = section;

    if (this._isEmptyContainer(type)) {
      return null;
    }

    let sudoClass = "";
    let lockedCaseClassName = "";
    if (mode === DOCUMENT_MODE.TEMPLATE) {
      sudoClass = " sudo-class ";
      if (this.props.totalRowItems > 2) {
        sudoClass += " reduce-width ";
      }
    } else if (mode === DOCUMENT_MODE.DOCUMENT && section.lock) {
      lockedCaseClassName = "locked-component-action";
    }
    let actionBtns = null;
    if (
      isComponentActive &&
      !this.state.showAddComponentBtns &&
      !this.props.isPdfDocument &&
      !this.props.isLocked
    ) {
      actionBtns = (
        <div
          ref={this.sectionActionBtnsRef}
          className={`component-wrapper ${
            !isLocked ? "drag-button-space" : ""
          } ${section.type === "Table" ? "table-wrapper" : ""}`}
          data-test="documentitems-component-wrapper-template-component-doc-view">
          {" "}
          <div
            className={`component-action ${
              !isLocked ? "action-padding" : ""
            } ${sudoClass} ${lockedCaseClassName}`}
            data-test="documentitems-component-action-template-component-doc-view">
            {" "}
            {!isLocked &&
              !this._isEmptyContainer(type) &&
              this._deleteButton()}{" "}
            {!isLocked &&
              !this._isEmptyContainer(type) &&
              isComponentCloneable(type) &&
              this._cloneButton()}{" "}
            {!isLocked && !this._isEmptyContainer(type) && this._clauseButton()}{" "}
            {!isLocked && !this._isEmptyContainer(type) && this._lockButton()}{" "}
            {!isLocked && !this._isEmptyContainer(type) && this._editButton()}{" "}
            {!isLocked &&
              this._isGoogleSheet(type) &&
              this._manageColumnsButton()}{" "}
            {this._clauseOptionButton()}{" "}
          </div>
        </div>
      );
    } else if (
      this.props.isPdfDocument &&
      this.props.stage === "DRAFT" &&
      !this.props.isSharedDocument
    ) {
      actionBtns = (
        <div
          ref={this.sectionActionBtnsRef}
          className={`component-wrapper ${
            section.type === "Table" ? "table-wrapper" : ""
          }`}
          data-test="documentitems-component-wrapper-template-component-doc-view">
          {" "}
          <div
            className={`component-action ${
              !isLocked ? "action-padding" : ""
            } ${sudoClass}`}
            data-test="documentitems-component-action-template-component-doc-view">
            {" "}
            {!isLocked &&
              !this._isEmptyContainer(type) &&
              this._deleteButton()}{" "}
            {!isLocked && !this._isEmptyContainer(type) && this._clauseButton()}{" "}
            {!isLocked && !this._isEmptyContainer(type) && this._lockButton()}{" "}
            {!isLocked && !this._isEmptyContainer(type) && this._editButton()}{" "}
            {!isLocked &&
              this._isGoogleSheet(type) &&
              this._manageColumnsButton()}{" "}
            {this._clauseOptionButton()}{" "}
          </div>{" "}
        </div>
      );
    }

    return actionBtns;
  };

  // Get the document component item class names based on component types
  _getItemViewClassName = () => {
    const {
      // isHoverdComponentActive,
      isSharedDocument,
      section,
      // clickedActiveComponentId,
      isComponentActive,
    } = this.props;
    let className = "component-items "; // Default class name all section

    // additional class name for PageBreak section
    if (section.type === DOCUMENT_COMPONENT_TYPES.PAGE_BREAK) {
      className += " pagebreak-component-items ";
    }
    // additional class name for LineSpace section
    if (section.type === DOCUMENT_COMPONENT_TYPES.LINE_SPACE) {
      className += " linespace-component-items ";
    }
    // additional class name for Table section
    if (section.type === DOCUMENT_COMPONENT_TYPES.TABLE) {
      className += " table-component-items  ";
    }
    if (isComponentActive) {
      className += " active active-clicked isactivecomponent";
    }

    // If it is a "Shared Document"
    if (isSharedDocument) {
      className += " shareddocument-component-items ";
    }

    if (this.state.showAddComponentBtns) {
      className += " isactivecomponent ";
    }
    return className;
  };

  _itemView = () => {
    const {
      section,
      isLocked,
      isSharedDocument,
      isComponentActive,
      draggedSection,
    } = this.props;
    const { id, lock } = section;
    let className = "doc-component ";
    if (lock && !isLocked) {
      className += " locked-component ";
    }
    if (isLocked && section.type !== "Image") {
      className += " edit-locked  ";
    }
    if (section.type === "Image") {
      if (isComponentActive && !this.state.showAddComponentBtns) {
        className += " image-options ";
      }
      if (isLocked) {
        if (!(this.props.showForm && section.clauseOptions)) {
          className += " edit-locked ";
        }
      } else if (
        section.clauseOptions &&
        (this.props.mode === DOCUMENT_MODE.TEMPLATE ||
          (this.props.mode === DOCUMENT_MODE.TEMPLATE && this.props.showForm))
      ) {
        className += " locked-component ";
      }
    }
    if (isSharedDocument) {
      className += " shared-document-component";
    }

    const sectionView = this._getSectionView();

    if (!sectionView) {
      return null;
    }

    const isDragged = draggedSection && section.id === draggedSection.id;

    return (
      <div
        ref={this.docSectionRef}
        data-test="documentitems-component-item-inside-template-doc-wrapper"
        id={section.id}
        className={`${this._getItemViewClassName()} ${
          section.type === DOCUMENT_COMPONENT_TYPES.EMPTY_CONTAINER
            ? "empty-container"
            : ""
        } ${isDragged ? "dragged-component" : ""}`}>
        <div
          data-test="documentitems-component-item-inside-template-doc"
          className={className}
          id={`document-item-section-${id}`}
          key={id}>
          {/* ------ Document Component Drag button ------ */}
          {this._decideDragActionBtns()}
          {/* ------ Document Component Action's buttons section ------ */}
          {(!draggedSection || this.props.draggedFrom === "new-component") &&
            this._decideSectionActionBtns()}
          {/* ------ Document Component View section ------ */}
          {sectionView}
        </div>
      </div>
    );
  };

  // setTimout is used to fix a chrome bug
  // which causes the dragEnd to call immediately
  _onDragStart = (event, section) => {
    if (this.state.dragImg) {
      event.dataTransfer.setDragImage(this.state.dragImg, 0, 0);
    }
    event.dataTransfer.effectAllowed = "all";

    setTimeout(() => {
      const { itemType, rowIndex, colIndex } = this.props;
      this.props.updateDraggedSection(section, itemType, rowIndex, colIndex);
    }, 0);
  };

  _onDragEnd = () => {
    this.props.updateDraggedSection(null, null, null, null);
    this.props.preventComponentToDeactivate(true);
  };

  _redirectToDealTable = () => {
    if (!this.props.isSharedDocument) {
      this.props.toggleTabView("DEAL_TABLE");
    }
  };

  _getSectionView = () => {
    const {
      mode,
      itemType,
      sectionID,
      section,
      component,
      componentMeta,
      isLocked,
      openDealTable,
      clauses,
      updateComponent,
      isSharedDocument,
      isDocumentLocked,
      clickedActiveComponentId,
      isHoverdComponentActive,
      showDocumentDiffView,
      currentEditorState,
      removeHighlightSelection,
      updateHoveredSectionId,
      hoveredActiveComponentId,
      undoId,
    } = this.props;
    const { type } = section;
    const sectionData = {
      mode,
      sectionID,
      section,
      component,
      componentMeta,
      isLocked,
      clauses,
      isHoverdComponentActive,
      isDocumentLocked,
      clickedActiveComponentId,
      handleBlur: updateComponent,
      updateHoveredSectionId,
    };
    switch (type) {
      case DOCUMENT_COMPONENT_TYPES.EMPTY_SIGNATURE_CONTAINER:
        return (
          <SignatureContainer
            {...sectionData}
            createDocSectionRef={this._createDocSectionRef}
            signatureWrapperRef={this.props.signatureWrapperRef}
            totalRowItems={this.props.totalRowItems}
          />
        );
      case DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET:
        return (
          <GoogleSheetContainer
            {...sectionData}
            hiddenCols={this.state.hiddenColumnsForGsheet}
            createDocSectionRef={this._createDocSectionRef}
            hoveredActiveComponentId={hoveredActiveComponentId}
          />
        );
      case DOCUMENT_COMPONENT_TYPES.HTML:
        return (
          <CustomText
            {...sectionData}
            editClauseOption={this.props.editClauseOption}
            removeHighlightSelection={removeHighlightSelection}
            showDocumentDiffView={showDocumentDiffView}
            currentEditorState={currentEditorState}
            clauseOptionsDetails={this.props.clauseOptionsDetails}
            setRefsByType={this.props.setRefsByType}
            createDocSectionRef={this._createDocSectionRef}
            updateDocumentClickedComponentID={
              this.props.updateDocumentClickedComponentID
            }
            customToolbarRef={this.props.customToolbarRef}
          />
        );
      case DOCUMENT_COMPONENT_TYPES.TABLE:
        return (
          <Table
            {...sectionData}
            headers={[]}
            removeHighlightSelection={removeHighlightSelection}
            showDocumentDiffView={showDocumentDiffView}
            readOnly={isLocked || section.lock}
            showHyperlinkBox={this._showHyperlinkBox}
            closeHyperlinkBox={this._closeHyperlinkBox}
            getEditorState={this._getEditorState}
            sectionActionBtnsRef={this.sectionActionBtnsRef}
            isHoverdComponentActive={isHoverdComponentActive}
            hoveredActiveComponentId={hoveredActiveComponentId}
            customToolbarRef={this.props.customToolbarRef}
            createDocSectionRef={this._createDocSectionRef}
            tableFor="DOCUMENT_SECTION"
            className="revv-table"
            totalRowItems={this.props.totalRowItems}
            disablePlusBtnHandler={this.props.disablePlusBtnHandler}
            tableColorpickerDropdownRef={this.props.tableColorpickerDropdownRef}
            openTableColorpicker={this.props.openTableColorpicker}
            closeTableColorpicker={this.props.closeTableColorpicker}
          />
        );
      case DOCUMENT_COMPONENT_TYPES.IMAGE:
        return (
          <CustomImage
            {...sectionData}
            replaceImage={this.state.replaceImage}
            openFileBrowser={this._clearReplaceImage}
            setRefsByType={this.props.setRefsByType}
            createDocSectionRef={this._createDocSectionRef}
            addAltText={this._addAltText}
            key={undoId}
            totalRowItems={this.props.totalRowItems}
            disablePlusBtnHandler={this.props.disablePlusBtnHandler}
            imageFormFieldDetails={this.props.clauseOptionsDetails}
            match={this.props.match}
            isSharedDocument={this.props.isSharedDocument}
          />
        );
      case DOCUMENT_COMPONENT_TYPES.DEAL_TABLE:
        return (
          <CustomDealTable
            {...sectionData}
            openDealTable={openDealTable}
            showDocumentDiffView={showDocumentDiffView}
            isSharedDocument={isSharedDocument}
            createDocSectionRef={this._createDocSectionRef}
            redirectToDealTable={() => this._redirectToDealTable()}
          />
        );
      case DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE:
        return (
          <CustomQuoteTable
            {...sectionData}
            openQuoteTable={openDealTable}
            isSharedDocument={isSharedDocument}
            createDocSectionRef={this._createDocSectionRef}
            redirectToDealTable={() => this._redirectToDealTable()}
          />
        );
      case DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE_WRAPPER:
        return (
          <CustomQuoteTableWrapper
            {...sectionData}
            isSharedDocument={isSharedDocument}
            redirectToDealTable={() => this._redirectToDealTable()}
            createDocSectionRef={this._createDocSectionRef}
          />
        );
      case DOCUMENT_COMPONENT_TYPES.EMPTY_CONTAINER: {
        // Decide whether to show the Blank Document Placeholder(image) or not
        // const { docComponentSectionList: secList, draggedSection } = this.props;
        const { draggedSection, stage } = this.props;
        let hidePlaceholder = false;
        if (
          // secList &&
          // secList.length === 1 &&
          // secList[0].type === DOCUMENT_COMPONENT_TYPES.EMPTY_CONTAINER &&
          draggedSection ||
          isSharedDocument ||
          stage !== "DRAFT"
        ) {
          hidePlaceholder = true;
        }
        return (
          <EmptyDocumentPlaceholder
            itemType={itemType}
            hidePlaceholder={hidePlaceholder}
          />
        );
      }
      case DOCUMENT_COMPONENT_TYPES.PAGE_BREAK:
        return (
          <CustomPageBreak
            {...sectionData}
            createDocSectionRef={this._createDocSectionRef}
          />
        );
      case DOCUMENT_COMPONENT_TYPES.LINE_SPACE:
        return (
          <CustomLineSpace
            {...sectionData}
            createDocSectionRef={this._createDocSectionRef}
          />
        );
      case DOCUMENT_COMPONENT_TYPES.STRIPE_PAYMENT_BUTTON:
        return (
          <StripePaymentContainer
            createDocSectionRef={this._createDocSectionRef}
            isSharedDocument={this.props.isSharedDocument}
            {...sectionData}
          />
        );
      default:
        return null;
    }
  };

  _createDocSectionRef = element => {
    this.docSectionRef = element;
    this.props.setRefsByType("DOCUMENT_SECTION", this.docSectionRef);
  };

  _setMngColsData = (hdnCols, newColHdrs) => {
    const { section } = this.props;
    const currentSec = { ...section };
    this.setState({
      hiddenColumnsForGsheet: hdnCols,
      columnsHeaders: newColHdrs,
    });
    if (section && section.type === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET) {
      const newSection = {
        ...section,
        data: {
          attributes: {},
          ...section.data,
        },
      };
      newSection.data.attributes.hiddenCols = hdnCols;
      if (
        "columnCount" in newSection.data.attributes &&
        "originalColumnCount" in newSection.data.attributes
      ) {
        newSection.data.attributes.columnCount =
          newSection.data.attributes.originalColumnCount - hdnCols.length;
      }
      updateSecInDocReduxAndBackend(newSection, currentSec);
    }
  };

  _closePopup = () => {
    this.setState({
      openModal: false,
      addedAltTextBool: false,
    });
  };

  _onChange = e => {
    this.setState({ AltTextValue: e.target.value });
  };

  _getImageDimension = data =>
    new Promise(res => {
      const img = new Image();
      img.onload = () => {
        const newDimensions = this._reduceDimensions(img.width, img.height);
        res(newDimensions);
      };
      img.src = data;
    });

  _saveAltText = () => {
    const { AltTextValue, lastAddedAltText } = this.state;
    let { addedAltTextBool } = this.state;
    const { section, updateComponent } = this.props;

    if (this._isBase64(section.data)) {
      section.data = JSON.stringify({
        image: section.data,
        altText: AltTextValue,
      });
    } else {
      try {
        let newImageData = JSON.parse(section.data);
        newImageData = { ...newImageData, altText: AltTextValue };
        section.data = JSON.stringify(newImageData);
      } catch (e) {
        console.error(`DocumentItems => _saveAltText => Error : ${e}`);
      }
    }

    updateComponent(section, true, false, section);
    this.props.forceUpdateEditorSectionIdAction(this.props.section.id); // need to re-render the custom image
    addedAltTextBool = true;
    let Message = "";
    if (addedAltTextBool && this.state.lastAddedAltText === "") {
      Message = "Alt-text has been added successfully";
      Toastr.showToastr({
        className: "is-success",
        message: Message,
        timeout: 2000,
      });
    } else if (
      addedAltTextBool &&
      lastAddedAltText &&
      lastAddedAltText !== AltTextValue
    ) {
      Message = "Alt-text has been updated successfully";
      Toastr.showToastr({
        className: "is-success",
        message: Message,
        timeout: 2000,
      });
    }

    this.setState({
      lastAddedAltText: AltTextValue,
      addedAltTextBool: false,
    });
    this._closePopup();
  };

  render() {
    const {
      openModal,
      showClauseSave,
      sectionIdForClause,
      showDeleteConfirmation,
      showRemoveClauseConfirmation,
      showRemoveClauseOptionsConfirmation,
      // showHyperlinkBoxConfirmation,
      showManageColumnPopup,
    } = this.state;
    const { section, sectionID } = this.props;
    const sectionView = this._itemView();
    if (!section || section.id !== sectionID || !sectionView) {
      return null;
    }
    let popusspace = null;
    let sectionDeleteConfirmationPopupSpace = null;
    let showRemoveClauseConfirmationPopupSpace = null;
    let showRemoveClauseOptionsConfirmationPopupSpace = null;
    // const showHyperlinkBoxConfirmationPopupSpace = null;
    let showAltTextPopupSpace = null;
    let showManageColumnsForGsheet = null;

    const showLabel = section.label ? ` "${section.label}"` : "";
    if (openModal) {
      showAltTextPopupSpace = (
        <Modal open onClose={this._closePopup} center>
          <div className="inviteteammatespopup-wrapper">
            <div className="inviteteammatespopup-modal-heading">
              Add alt-text for your image
            </div>

            <div className="inviteteammatespopup-description-section">
              <span className="inviteteammatespopup-description-text">
                All text is an alternative text that gets rendered if your image
                does not load. It also improves web accessibility and
                searchability of documents, if you post them on public web
                platforms.
              </span>
            </div>

            <div className="inviteteammatespopup-form">
              <div className="form-group">
                <Label htmlFor="userEmail">Alt-text</Label>
                <div className="inviteteammatespopup-copyblock">
                  <Input
                    data-test="alt-text-input-box"
                    onChange={this._onChange}
                    onKeyDown={this._handleKeyDown}
                    className="alt-text-input"
                    type="text"
                    placeholder="Enter description"
                    value={this.state.AltTextValue}
                    autoFocus
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="createquotepopup-footer popup-footer">
            <div className="footer-actions">
              <Button
                data-test="alt-text-cancel-button"
                className="btn btn-transparent createquotepopup-footer-cancelbtn"
                onClick={this._closePopup}>
                Cancel
              </Button>
              {this.state.AltTextValue === "" ? (
                <Button
                  data-test="alt-text-save-button"
                  disabled
                  className="btn btn-primary">
                  Save
                </Button>
              ) : (
                <Button
                  onClick={this._saveAltText}
                  data-test="alt-text-save-button"
                  className="btn btn-primary">
                  Save
                </Button>
              )}
            </div>
          </div>
        </Modal>
      );
    }

    if (showClauseSave) {
      popusspace = (
        <Modal
          open={this.state.showClauseSave}
          center
          closeOnOverlayClick={false}
          onClose={this._closeClausePopUp}>
          <CreateClause
            sectionId={sectionIdForClause}
            closePopup={this._closeClausePopUp}
            confirmAction={this._createClause}
            updateDocumentClickedComponentID={updateDocumentClickedComponentID}
          />
        </Modal>
      );
    } else if (showDeleteConfirmation) {
      const label = showLabel === "" ? "" : truncateString(showLabel, 60, true);
      sectionDeleteConfirmationPopupSpace = (
        <ConfirmationBox
          show={showDeleteConfirmation}
          name="doc-delete-section"
          closePopup={() => this.setState({ showDeleteConfirmation: false })}
          header={`Are you sure you want to DELETE this section ${label} ?`}
          subHeader={`Once deleted, you won't be able to undo this action.`}
          checkboxLabel="Yes, I want to delete."
          confirmAction={this._deleteSection}
          okBtnText="Delete Section"
          disableCheckbox
          confirmationBoxRef={this.props.docDeletePopupRef}
        />
      );
    } else if (showManageColumnPopup) {
      showManageColumnsForGsheet = (
        <ManageColumnsPopup
          show={this.state.showManageColumnPopup}
          closePopup={() => this.setState({ showManageColumnPopup: false })}
          columns={this.state.columnsHeaders}
          setMngColsData={this._setMngColsData}
        />
      );
    } else if (showRemoveClauseConfirmation) {
      showRemoveClauseConfirmationPopupSpace = (
        <ConfirmationBox
          show={showRemoveClauseConfirmation}
          name="remove-clause"
          closePopup={() =>
            this.setState({ showRemoveClauseConfirmation: false })
          }
          header={`Are you sure you want to Remove Clause with this section ${showLabel} ?`}
          subHeader={`Once removed, you won't be able to add this clause.`}
          checkboxLabel="Yes, I want to remove."
          confirmAction={this._removeClause}
          okBtnText="REMOVE CLAUSE"
          confirmationBoxRef={this.props.docDeletePopupRef}
        />
      );
    } else if (showRemoveClauseOptionsConfirmation) {
      showRemoveClauseOptionsConfirmationPopupSpace = (
        <ConfirmationBox
          show={showRemoveClauseOptionsConfirmation}
          name="remove-clause-options"
          closePopup={() =>
            this.setState({ showRemoveClauseOptionsConfirmation: false })
          }
          header={`Are you sure you want to Remove Clause Options with this section ${showLabel} ?`}
          subHeader="Once removed, you will not be able to undo the process. Any workflows associated with this clause also will be removed."
          checkboxLabel="Yes, I want to remove."
          confirmAction={this._removeClauseOption}
          okBtnText="REMOVE CLAUSE OPTIONS"
          confirmationBoxRef={this.props.docDeletePopupRef}
        />
      );
    }

    // This is for upgrade popups of ConentLock/Add Clause Option
    const {
      showContentLockUpgradePopup,
      showAddClauseUpgradePopup,
    } = this.state;
    let contentUpgradePopup = null;
    let featureName = "";
    let decideType = "";
    if (showContentLockUpgradePopup) {
      featureName = FEATURES_NAME.DOCUMENTS_CONTENT_LOCKING;
      decideType = "showContentLockUpgradePopup";
    } else if (showAddClauseUpgradePopup) {
      featureName = FEATURES_NAME.TEMPLATES_CLAUSE_OPTIONS;
      decideType = "showAddClauseUpgradePopup";
    }
    if (showContentLockUpgradePopup || showAddClauseUpgradePopup) {
      contentUpgradePopup = (
        <UpgradePopUp
          featureName={featureName}
          onClose={() => this._toggleUpgradePopup(decideType, false)}
        />
      );
    }

    return (
      <Fragment>
        {contentUpgradePopup}
        {popusspace}
        {sectionDeleteConfirmationPopupSpace}
        {showManageColumnsForGsheet}
        {showRemoveClauseConfirmationPopupSpace}
        {showRemoveClauseOptionsConfirmationPopupSpace}
        {showAltTextPopupSpace}
        {/* {showHyperlinkBoxConfirmationPopupSpace} */}
        {this._itemView()}
      </Fragment>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { mode, componentMeta } = props;
  let clauseList = [];
  let isHoverdComponentActive = false;
  let docID;
  let clauseOptionsDetails;
  let tempDNFields = [];
  let undoId = "";
  let section = "";
  const {
    clickedActiveComponentId,
    hoveredActiveComponentId,
    components,
    document: { isPdfDocument, stage, showForm },
    draggedType,
    draggedFrom,
  } = state.DocumentStore;

  // get component using component meta data
  // this is to directly connect component to redux
  if (!isPdfDocument) {
    const component = getComponentFromInfo(components, componentMeta);

    section = component || props.component || emptyContainer();
  } else {
    section = props.component;
  }
  if (mode === DOCUMENT_MODE.DOCUMENT) {
    const {
      document: { id, fields_used: allDynamicFields },
      clauses,
      stack: { id: newUndoId },
    } = state.DocumentStore;
    clauseList = clauses;
    docID = id;
    tempDNFields = allDynamicFields;
    undoId = newUndoId;
  } else if (mode === DOCUMENT_MODE.TEMPLATE) {
    const {
      template: { id },
      clauses,
      dynamicFields: { fields },
      undoRedoId,
    } = state.TemplateStore;
    clauseList = clauses;
    docID = id;
    tempDNFields = fields;
    undoId = undoRedoId;
  }

  isHoverdComponentActive = section
    ? section.id === hoveredActiveComponentId
    : false;
  const { clauseID } = section;
  const clauses =
    clauseID && Array.isArray(clauseList)
      ? clauseList.find(
          clause =>
            (mode === DOCUMENT_MODE.TEMPLATE && clause.id === clauseID) ||
            (mode === DOCUMENT_MODE.DOCUMENT && clause.clause_id === clauseID),
        )
      : null;

  let tempClauseOptions = null;
  if (section && section.clauseOptions) {
    tempClauseOptions = section.clauseOptions;
  }

  if (tempClauseOptions && tempDNFields) {
    clauseOptionsDetails = tempDNFields.find(
      clause => clause.id === tempClauseOptions.id,
    );
  }

  // check if the section is in active state or hovered state
  let isComponentActive = clickedActiveComponentId === section.id;
  if (section && section.type === DOCUMENT_COMPONENT_TYPES.TABLE) {
    const { data: tableData } = section;
    // let hoveredCell = null;
    if (
      tableData &&
      Array.isArray(tableData.data) &&
      tableData.data.length > 0
    ) {
      tableData.data.forEach(row => {
        const { data: rowData } = row;
        if (Array.isArray(rowData)) {
          rowData.forEach(cell => {
            const { attributes } = cell;
            if (attributes && attributes.id === clickedActiveComponentId)
              isComponentActive = true;
          });
        }
      });
    }
  }
  return {
    draggedType,
    draggedFrom,
    docID,
    section,
    showForm,
    isHoverdComponentActive,
    hoveredActiveComponentId,
    clauses,
    clickedActiveComponentId,
    isComponentActive,
    clauseOptionsDetails,
    undoId,
    isPdfDocument,
    stage,
  };
};

const mapDispatchToProps = {
  makeActiveEditor,
  nukeEditorState,
  addClause,
  removeClause,
  addClauseOptions,
  editClauseOption,
  changeToolsView,
  updateTemplateSection,
  toggleTabView,
  updateAddComponentinToolbarAction,
  setSectionDataForActiveSignatureInRightToolPane,
  updateDocumentClickedComponentID,
  setSectionDataForActivePaymentButtonInRightToolPane,
  updateHoveredDocumentSectionId,
  updateDraggedSection,
  preventComponentToDeactivate,
  forceUpdateEditorSectionIdAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocumentItems);



// WEBPACK FOOTER //
// ./src/components/DocumentItems/DocumentItems.js